import script from "./AddProduct.vue?vue&type=script&setup=true&lang=js"
export * from "./AddProduct.vue?vue&type=script&setup=true&lang=js"

import "./AddProduct.vue?vue&type=style&index=0&id=6673189b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6673189b"]])

export default __exports__